<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> جستجوی سفرهای اداری  </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <form class="row gx-2 gy-3" [formGroup]="searchModel">

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <div class="col-12 col-md-auto position-relative">
    
            <label class="mb-2"> دلیل سفر </label>

            <select  class="form-select" formControlName="tiTripReason">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_TripReason" [value]="item.tiTripReason">
                    
                    {{item.strComment}} 
                
                </option>

            </select>

        </div>

        <div class="col-12 col-md-auto position-relative">
    
            <label class="mb-2"> کاربری خودرو </label>

            <select  class="form-select" formControlName="tiMobileType">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_MobileType" [value]="item.tiMobileType">
                    
                    {{item.strComment}} 
                
                </option>

            </select>

        </div>

        <div class="col-12 col-md-2 position-relative">
    
            <label class="mb-2"> جایگاه سازمانی </label>

            <select  class="form-select" formControlName="strChart">

                <option class="text-center" value=""> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_UserManager" [value]="item.strChart">
                    
                    {{item.strComment}} 
                
                </option>

            </select>

        </div>

        <div class="col-12 col-md-2 position-relative">
    
            <label class="mb-2"> وضعیت سفر </label>

            <select  class="form-select" formControlName="tiTripStatus">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_TripStatus" [value]="item.tiTripStatus">
                    
                    {{item.strComment}} 
                
                </option>

            </select>

        </div>

        <div class="col-12 col-md-3 position-relative">
    
            <label class="mb-2"> حوزه خدمت </label>

            <select  class="form-select" formControlName="iMobileDomain">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Domain" [value]="item.iMobileDomain">
                    
                    {{item.strComment}} 
                
                </option>

            </select>

        </div>

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <div class="btn-group" role="group">

                <input type="radio" class="btn-check" name="tiType" id="btnradio1" (click)="chooseTiType(-1)" [checked]="isSelected(-1)">

                <label class="btn btn-outline-secondary" for="btnradio1">همه</label>
              
                <input type="radio" class="btn-check" name="tiType" id="btnradio2" (click)="chooseTiType(0)" [checked]="isSelected(0)">

                <label class="btn btn-outline-secondary" for="btnradio2">یک طرفه</label>
              
                <input type="radio" class="btn-check" name="tiType" id="btnradio3" (click)="chooseTiType(1)" [checked]="isSelected(1)">
                
                <label class="btn btn-outline-secondary" for="btnradio3">رفت و برگشت</label>

                <input type="radio" class="btn-check" name="tiType" id="btnradio4" (click)="chooseTiType(2)" [checked]="isSelected(2)">
                
                <label class="btn btn-outline-secondary" for="btnradio4">در اختیار</label>

                <input type="radio" class="btn-check" name="tiType" id="btnradio5" (click)="chooseTiType(3)" [checked]="isSelected(3)">
                
                <label class="btn btn-outline-secondary" for="btnradio5">ماموریتی</label>

              </div>
            
        </div>

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="searchTrip()"> &nbsp; جستجو &nbsp; </button>

        </div>

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportexcel('Export_Excel')"> خروجی اکسل </button>

        </div>
    
    </form>

    <div class="border border-2 mt-3 p-2" >

        <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

        <div class="section border border-2 mt-2" style="height:calc(100vh - 270px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
                <thead>
            
                    <tr class="">
        
                        <th class="text-center col-1"> # </th>
    
                        <th class="text-center"> عملیات </th>
            
                        <th class="text-center"> کد سفر  </th>
    
                        <th class="text-center"> تاریخ ثبت </th>
        
                        <th class="text-center"> تاریخ سفر  </th>
                        
                        <th class="text-center"> ساعت سفر  </th>

                        <th class="text-center"> نام راننده  </th>
    
                        <th class="text-center"> متقاضی </th>
        
                        <th class="text-center"> جایگاه سازمانی </th>
                
                        <th class="text-center"> حوزه خدمت </th>
        
                        <th class="text-center"> دلیل سفر </th>

                        <th class="text-center"> وضعیت سفر </th>

                        <th class="text-center"> تاریخ پایان </th>

                        <th class="text-center"> پایان ماموریت </th>

                        <th class="text-center"> ساعت پایان </th>

                        <th class="text-center"> مدت سفر </th>

                        <th class="text-center"> پیمایش سفر </th>

                        <th class="text-center"> مبداء سفر </th>

                        <th class="text-center"> مقصد سفر </th>
        
                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Trips;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td> 

                            <i class="fa fa-eye fa-lg pointer" (click)="openViewModal(item)" title="مشاهده"></i>

                            <i class="fa fa-road fa-lg mx-2 pointer" (click)="showTripRoute(item)" title="مسیر"></i>

                        </td>

                        <td> {{ item.iOfficialTrip | faNum }} </td>

                        <td> {{ item.strRequestDate | faNum }} </td>

                        <td> {{ item.strTripStartDate | faNum }} </td>

                        <td> {{ item.strTrimpStartTime | faNum }} </td>

                        <td [innerHTML]="highlightText(item.strFullName,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strPassengersName,searchTerm.value)  | faNum"> </td>

                        <td> {{ item.strChartName | faNum }} </td>

                        <td> {{ item.strMobileDomain_Trip_strComment | faNum }} </td>

                        <td [innerHTML]="highlightText(item.strTripReason_strComment,searchTerm.value)  | faNum"> </td>

                        <td> {{ item.strTripStatus_strComment | faNum }} </td>

                        <td> {{ item.strTrimpFinishDate | faNum }} </td>

                        <td> {{ item.strEndMissionDate | faNum }} </td>

                        <td> {{ item.strTrimpFinishTime | faNum }} </td>

                        <td> {{ item.strTotalTripTime | faNum }} </td>

                        <td> {{ item.fTripKm | faNum }} </td>

                        <td class="text-center">

                            <div [innerHTML]="highlightText(item.strSourceAddress,searchTerm.value) | faNum"
                            
                                style="width: 320px;text-wrap: wrap;">
                                
                            </div>

                         </td>

                         <td class="text-center">

                            <div [innerHTML]="highlightText(item.strDestinationAddress,searchTerm.value) | faNum"
                            
                                style="width: 320px;text-wrap: wrap;">
                                
                            </div>

                         </td>

                    </tr>

                </tbody>
    
            </table>
    
        </div>

    </div>

</main>
 
<div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="viewModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="viewModalLabel"> مشاهده اطلاعات سفر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div dir="rtl" class="modal-body">

                <ul class="nav nav-tabs">

                    <!-- اطلاعات سفر -->

                    <li class="nav-item pointer" (click)="tabNumber = 0">

                         <a class="nav-link"  [ngStyle]="{'background-color': tabNumber == 0 ? '#e0f2fe': '' }" 
                         
                            [ngClass]="tabNumber == 0 ? 'active fw-bold text-muted' : 'text-muted fw-normal' ">
                            
                            اطلاعات سفر 
                        
                        </a>

                    </li>

                    <!-- نتیجه سفر -->
                     
                    <li class="nav-item pointer">

                        <ng-container *ngIf="trip_Obj.tiTripStatus == 9 || trip_Obj.tiTripStatus == 7; else tiTripStatus ">

                            <a class="nav-link"  (click)="openViewModal(trip_Obj,true);"
                        
                                [ngStyle]="{'background-color': tabNumber == 1 ? '#e0f2fe': '' }" 
                            
                                [ngClass]="tabNumber == 1 ? 'active fw-bold text-muted' : 'text-muted fw-normal' ">
                                
                                نتیجه سفر  
                        
                            </a>

                        </ng-container>

                        <ng-template #tiTripStatus>

                            <a class="nav-link disabled text-muted fw-normal" title="این گزینه برای این سفر غیرفعال می باشد">
                            
                                 نتیجه سفر  
                        
                            </a>

                        </ng-template>

                    </li>

                </ul>

                <!-- اطلاعات سفر -->

                <ng-container *ngIf="tabNumber == 0 && trip_Obj?.iOfficialTrip">

                    <div class="border border-1 rounded p-2">

                        <div class="container-fluid row gx-2 gy-2 p-2" >

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> کد رهگیری</label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.iOfficialTrip | faNum" disabled>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> نام و نام خانوادگی </label>
        
                                <input class="form-control text-center p-2" [value]="trip_Obj?.strApplicantName + ' '+ trip_Obj?.strApplicantFamily" disabled>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> شماره موبایل </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strApplicantMobile | faNum " disabled>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> دلیل سفر </label>
        
                                <ng-container *ngIf="!bEditMode; else tripReason">
        
                                    <input class="form-control text-center p-2" [value]="trip_Obj?.strTripReason_strComment" disabled>
        
                                </ng-container>
        
                                <ng-template #tripReason>
        
                                    <select formControlName="tiTripReason" class="form-select text-center p-2" style="background-color:#fefce8!important;">
        
                                        <option *ngFor="let item of tripReasons" value="{{item.tiTripReason}}">
            
                                            {{item.strComment}}
            
                                        </option>
            
                                    </select>
        
                                </ng-template>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> کاربری متحرک </label>
        
                                <ng-container *ngIf="!bEditMode; else mobileType">
        
                                    <input class="form-control text-center p-2" [value]="trip_Obj?.strMobileType_strComment" disabled>
        
                                </ng-container>
        
                                <ng-template #mobileType>
        
                                    <select formControlName="tiMobileType" class="form-select text-center p-2" style="background-color:#fefce8!important;">
        
                                        <option *ngFor="let item of vehicleTypes" value="{{item.tiMobileType}}">
            
                                            {{item.strComment}}
                                        
                                        </option>
            
                                    </select>
        
                                </ng-template>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> تاریخ درخواست </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strRequestDate | faNum" disabled>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> اهمیت سفر </label>
        
                                <input class="form-control p-2 text-center" 
                                
                                    [value]="trip_Obj?.strTripImportance_strComment | faNum" disabled>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> جایگاه سازمانی </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strChartName | faNum" disabled>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> ساعت درخواست </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strRequestTime.trim() | faNum" disabled>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> نوع سفر </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.bMission? 'مأموریتی': trip_Obj?.bExclusive? 'در اختیار': trip_Obj?.bHaveReturn? 'دو طرفه': 'یک طرفه'" disabled>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> تعداد سفرهای امروز جایگاه سازمانی </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.tiAppUsage + ' مورد ' | faNum" disabled>
        
                            </div>
        
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> حوزه خدمت متقاضی  </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strMobileDomain_strComment" disabled>
        
                            </div>
        
                            <div class="col-12 border border-1 my-3"></div>
        
                            <div class="position-relative col-12 col-md-6 p-2">
        
                                <label class="mb-2 text-muted"> همراهان </label>
        
                                <ng-container *ngIf="!bEditMode">
        
                                    <input class="form-control text-center p-2" [value]="trip_Obj?.strPassengersName" disabled>
        
                                </ng-container>
        
                                <ng-container *ngIf="bEditMode">
        
                                    <input type="text" class="form-control p-2" style="background-color:#fefce8!important;"
                                    
                                        formControlName="strPassengersName" [value]="trip_Obj?.strPassengersName">
        
                                </ng-container>
        
        
                            </div>
        
                            <div class="position-relative col-12 col-md-6 p-2">
        
                                <label class="mb-2 text-muted"> موبایل همراهان </label>
        
                                <input class="form-control p-2 text-end" 
                                
                                    [value]="trip_Obj?.strPassengersMobile | faNum" disabled>
        
                            </div>
        
                            <div class="position-relative col-12  p-2">
        
                                <label class="mb-2 text-muted"> مبدأ </label>
        
                                <ng-container *ngIf="!bEditMode">
        
                                    <input class="form-control  p-2" [value]="trip_Obj?.strSourceAddress" disabled>
        
                                </ng-container>
        
                                <ng-container *ngIf="bEditMode">
        
                                    <input type="text" class="form-control p-2" style="background-color:#fefce8!important;"
                                    
                                        formControlName="strSourceAddress" [value]="trip_Obj?.strSourceAddress">
        
                                </ng-container>
        
        
                            </div>
        
                            <div class="position-relative col-12  p-2">
        
                                <label class="mb-2 text-muted"> مقصد </label>
        
                                <ng-container *ngIf="!bEditMode">
        
                                    <input class="form-control p-2" [value]="trip_Obj?.strDestinationAddress" disabled>
        
                                </ng-container>
        
                                <ng-container *ngIf="bEditMode">
        
                                    <input type="text" class="form-control p-2" style="background-color:#fefce8!important;"
                                    
                                        formControlName="strDestinationAddress" [value]="trip_Obj?.strDestinationAddress">
        
                                </ng-container>
        
                            </div>
        
                            <div class="position-relative col-12  p-2">
        
                                <label class="mb-2 text-muted"> توضیحات </label>
        
                                <ng-container *ngIf="!bEditMode">
        
                                    <input class="form-control p-2" [value]="trip_Obj?.strComment" disabled>
        
                                </ng-container>
        
                                <ng-container *ngIf="bEditMode">
        
                                    <input type="text" formControlName="strComment"  style="background-color:#fefce8!important;"
                                    
                                        class="form-control p-2" [value]="trip_Obj?.strComment">
        
                                </ng-container>
        
                            </div>
        
                        </div>

                    </div>

                </ng-container>

                <!-- نتیجه سفر -->

                <ng-container *ngIf="tabNumber == 1">

                    <div class="border border-1 rounded p-2">

                        <div class="container-fluid row gx-2 gy-2 p-2" >

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> نام راننده </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strFullName | faNum" disabled>
        
                            </div>

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> حوزه خدمت راننده </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strMobileDomain_Trip_strComment | faNum" disabled>
        
                            </div>

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> ساعت اعلام آمادگی  </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strRedy4TrimpTime | faNum" disabled>
        
                            </div>
                            
                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> تاریخ شروع سفر  </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strTripStartDate | faNum" disabled>
        
                            </div>

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> ساعت شروع سفر  </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strTrimpStartTime | faNum" disabled>
        
                            </div>

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> تاریخ پایان سفر </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strTrimpFinishDate | faNum" disabled>
        
                            </div>

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> تاریخ پایان ماموریت </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strEndMissionDate | faNum" disabled>
        
                            </div>

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> ساعت پایان سفر </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strTrimpFinishTime | faNum" disabled>
        
                            </div>

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> مدت سفر </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.strTotalTripTime | faNum" disabled>
        
                            </div>

                            <div class="position-relative col-12 col-md-3 p-2">
        
                                <label class="mb-2 text-muted"> پیمایش سفر </label>
        
                                <input class="form-control p-2 text-center" [value]="trip_Obj?.fTripKm | faNum" disabled>
        
                            </div>

                            <div class="position-relative col-12 col-md-3 p-2">

                                <button class="btn btn-primary w-100 h-100"  (click)="showTripRoute(trip_Obj)">
                                    
                                    مسیر حرکتی 
                                
                                </button>

        
                            </div>

                        </div>

                    </div>

                    <div  class="border border-1 w-100 rounded p-2 mt-2" style="height: 400px;">

                        <div id="mapContainer" class="w-100 h-100">

                        </div>

                    </div>

                </ng-container>

            </div>

            <div class="modal-footer"></div>

        </div>

    </div>

</div>

